"use strict";
exports.__esModule = true;
exports.crystal = void 0;
var client_1 = require("./native/client");
exports.crystal = {
    info: {
        key: 'crystal',
        title: 'Crystal',
        extname: '.cr',
        "default": 'native'
    },
    clientsById: {
        native: client_1.native
    }
};
//# sourceMappingURL=target.js.map